import { useState } from "react";
import axios from "axios";
import { API_BASE_PATH } from "../../actions/constant";
import { useCombined } from '../../../common/base/CombinedContext';
import { useToast } from '../../../common/base/ToastContext';

const overViewInitialRes = {
  results: [
    {
      metrics: [
        {
          name: "REQUESTS_VOLUME",
          tags: {},
          columns: ["time", "sum"],
          values: [],
        },
      ],
    },
    {
      metrics: [
        {
          name: "FAILED_REQUESTS",
          tags: {},
          columns: ["time", "sum"],
          values: [],
        },
      ],
    },
    {
      metrics: [
        {
          name: "TOTAL_4XX_REQUESTS",
          tags: {},
          columns: ["time", "sum"],
          values: [],
        },
      ],
    },
    {
      metrics: [
        {
          name: "TOTAL_5XX_REQUESTS",
          tags: {},
          columns: [],
          values: [],
        },
      ],
    },
    {
      metrics: [
        {
          name: "AVERAGE_RESPONSE_TIME",
          tags: {},
          columns: ["time", "sum_sum"],
          values: [],
        },
      ],
    },
  ],
};

const requestsMetricsInitialData = {
  results: [
    {
      metrics: [
        {
          name: "REQUESTS_BY_METHOD",
          tags: {},
          columns: ["time", "sum"],
          values: [],
        },
      ],
    },
    {
      metrics: [
        {
          name: "REQUESTS_BY_RESPONSE_CODE",
          tags: {},
          columns: ["time", "sum"],
          values: [],
        },
      ],
    },
    {
      metrics: [
        {
          name: "REQUESTS_BY_REQUEST_SIZE",
          tags: {},
          columns: ["time", "sum"],
          values: [],
        },
      ],
    },
    {
      metrics: [
        {
          name: "REQUESTS_BY_RESPONSE_SIZE",
          tags: {},
          columns: [],
          values: [],
        },
      ],
    },
  ],
};

const failuresMetricsInitialData = {
  results: [
    {
      metrics: [
        {
          name: "FAILURES_BY_METHOD",
          tags: {},
          columns: ["time", "sum"],
          values: [],
        },
      ],
    },
    {
      metrics: [
        {
          name: "FAILURES_BY_RESPONSE_CODE",
          tags: {},
          columns: ["time", "sum"],
          values: [],
        },
      ],
    },
    {
      metrics: [
        {
          name: "FAILURES_BY_REQUEST_SIZE",
          tags: {},
          columns: ["time", "sum"],
          values: [],
        },
      ],
    },
    {
      metrics: [
        {
          name: "FAILURES_BY_RESPONSE_SIZE",
          tags: {},
          columns: [],
          values: [],
        },
      ],
    },
  ],
};

const clientApplicationInitialData = {
  results: [
    {
      metrics: [
        {
          name: "",
          tags: {},
          columns: ["time", "sum"],
          values: [],
        },
      ],
    }
  ]
}

const useApiMetrics = () => {
  const [loading, setLoading] = useState(false);
  const [metricsData, setMetricsData] = useState(null);
  const { showLoader, hideLoader } = useCombined();
  const { showToast } = useToast();
  
  const getMetricsData = (requestPayload, reload=false) => {
    if(!requestPayload.organizationId) {
      setMetricsData(null);
      return;
    }
    showLoader("getMetricsData");
    axios
      .post(`${API_BASE_PATH}/publisher_metrics/api_metrics`, requestPayload)
      .then((res) => {
        if (res.data) {
          setMetricsData(res.data);
        }
      })
      .catch((error) => {
        console.error(error);
        if(error.status === 504){
          showToast({
              title: 'Operation Failed',
              bg: 'danger',
              message: "Server is busy at the moment, please try again after sometime",
          });
        }
        setMetricsData(null);
      })
      .finally(() => {
        hideLoader("getMetricsData");
      });
  };

  return {
    loading,
    metricsData,
    overViewInitialRes,
    requestsMetricsInitialData,
    failuresMetricsInitialData,
    clientApplicationInitialData,
    getMetricsData,
    setMetricsData,
  };
};

export default useApiMetrics;
